import React, { useEffect, useState } from "react";
import { Input, Label, ComboBox, ComboBoxItem, FlexBox, FlexBoxDirection, RadioButton, Button } from "@ui5/webcomponents-react";
import UIModel from "../models/UIModel.json";

const SocioeconomicForm5 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  const {
    disasterTypeOptions,
    evacuationAreaOptions,
    disasterImpactOptions,
    experiencedDisaster = ["Oo", "Hindi"],
    assistanceTypeOptions,
    assistanceSourceOptions
  } = UIModel.disasterManagement;
  const [extraExperiencedDisaster, setExtraExperiencedDisaster] = useState(formData.extraExperiencedDisaster || []);

  useEffect(() => {
    const hasDisasterType = formData.disasterType;

    if (hasDisasterType) {
      onFormChange('experiencedDisaster', 'Oo');
    } else {
      onFormChange('experiencedDisaster', 'Hindi');
    }
  }, [formData.disasterType, onFormChange]);

  useEffect(() => {
    onFormChange("extraExperiencedDisaster", extraExperiencedDisaster);
  }, [onFormChange, extraExperiencedDisaster])

  const addExtraExperiencedDisaster = () => {
    if (!extraExperiencedDisaster) {
      setExtraExperiencedDisaster([{
        disasterType: null,
        evacuationArea: null,
        disasterImpact: null,
        assistanceType: null,
        assistanceSource: null
      }])
    } else if (Array.isArray(extraExperiencedDisaster)) {
      setExtraExperiencedDisaster((prev) => [...prev, {
        disasterType: null,
        evacuationArea: null,
        disasterImpact: null,
        assistanceType: null,
        assistanceSource: null
      }])
    }
  }

  const handleInputChange = (index, field, value) => {
    setExtraExperiencedDisaster((prev) =>
      prev.map((entry, i) =>
        i === index ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleDeleteEntry = (index) => {
    setExtraExperiencedDisaster((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>Step 5: Disaster Risk Reduction and Management</h2>
      <h3>C15. Nakaranas ba ng kalamidad sa nakalipas na 12 buwan?</h3>
      <FlexBox direction={FlexBoxDirection.Column} style={{ marginBottom: "1rem" }}>
        <FlexBox style={{ gap: "1rem" }}>
          {experiencedDisaster.map((option) => (
            <RadioButton
              key={option}
              text={option}
              value={option} 
              checked={formData.experiencedDisaster === option}
              onChange={(e) => {
                const selectedOption = e.target.value;
                // Update the form data based on the selected option
                if (selectedOption === "Hindi") {
                  onFormChange('experiencedDisaster', 'Hindi');
                  onFormChange('disasterType', null);
                  onFormChange('evacuationArea', null); 
                  onFormChange('disasterImpact', null);
                  onFormChange('assistanceType', null);
                  onFormChange('assistanceSource', null);
                  onFormChange('extraExperiencedDisaster', null);
                } else {
                  onFormChange('experiencedDisaster', 'Oo');
                }
              }}
            />
          ))}
        </FlexBox>
      </FlexBox>
      {formData.experiencedDisaster === 'Oo' && <>
      {/* a. Uri ng Kalamidad */}
      <h2>Experienced Disaster 1</h2>
      <h3>a. Uri ng Kalamidad</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Disaster Type</Label>
      <ComboBox
        value={disasterTypeOptions.find(option => option.value === formData.disasterType)?.label || ""}
        onChange={(e) => {
          const selectedValue = disasterTypeOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("disasterType", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {disasterTypeOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.disasterType === 99 && (
        <Input
          name="disasterTypeOther"
          value={formData.disasterTypeOther || ""}
          onInput={(e) => onFormChange("disasterTypeOther", e.target.value.toUpperCase())}
          placeholder="Specify other disaster type"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* b. Uri ng Evacuation Area */}
      <h3>b. Uri ng Evacuation Area</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Evacuation Area</Label>
      <ComboBox
        value={evacuationAreaOptions.find(option => option.value === formData.evacuationArea)?.label || ""}
        onChange={(e) => {
          const selectedValue = evacuationAreaOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("evacuationArea", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {evacuationAreaOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.evacuationArea === 99 && (
        <Input
          name="evacuationAreaOther"
          value={formData.evacuationAreaOther || ""}
          onInput={(e) => onFormChange("evacuationAreaOther", e.target.value.toUpperCase())}
          placeholder="Specify other evacuation area"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* c. Epekto o Damage na Naranasan */}
      <h3>c. Epekto o Damage na Naranasan</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Disaster Impact</Label>
      <ComboBox
        value={disasterImpactOptions.find(option => option.value === formData.disasterImpact)?.label || ""}
        onChange={(e) => {
          const selectedValue = disasterImpactOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("disasterImpact", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {disasterImpactOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.disasterImpact === 99 && (
        <Input
          name="disasterImpactOther"
          value={formData.disasterImpactOther || ""}
          onInput={(e) => onFormChange("disasterImpactOther", e.target.value.toUpperCase())}
          placeholder="Specify other disaster impact"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* d. Uri ng Tulong na Natanggap */}
      <h3>d. Uri ng Tulong na Natanggap</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Assistance Type</Label>
      <ComboBox
        value={assistanceTypeOptions.find(option => option.value === formData.assistanceType)?.label || ""}
        onChange={(e) => {
          const selectedValue = assistanceTypeOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("assistanceType", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {assistanceTypeOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.assistanceType === 99 && (
        <Input
          name="assistanceTypeOther"
          value={formData.assistanceTypeOther || ""}
          onInput={(e) => onFormChange("assistanceTypeOther", e.target.value.toUpperCase())}
          placeholder="Specify other assistance type"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
      )}

      {/* e. Pinanggalingan ng Tulong */}
      {formData.assistanceType !== 7 && <>
      <h3>e. Pinanggalingan ng Tulong</h3>
      <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Assistance Source</Label>
      <ComboBox
        value={assistanceSourceOptions.find(option => option.value === formData.assistanceSource)?.label || ""}
        onChange={(e) => {
          const selectedValue = assistanceSourceOptions.find(option => option.label === e.target.value)?.value || null;
          onFormChange("assistanceSource", selectedValue);
        }}
        style={{ width: "100%", marginBottom: "1rem" }}
      >
        {assistanceSourceOptions.map(option => (
          <ComboBoxItem key={option.value} text={option.label} />
        ))}
      </ComboBox>
      {formData.assistanceSource === 99 && (
        <Input
          name="assistanceSourceOther"
          value={formData.assistanceSourceOther || ""}
          onInput={(e) => onFormChange("assistanceSourceOther", e.target.value.toUpperCase())}
          placeholder="Specify other assistance source"
          style={{ width: "100%", textTransform: "uppercase" }}
        />
        )}
        </>} 
        {extraExperiencedDisaster && Array.isArray(extraExperiencedDisaster) && extraExperiencedDisaster.map((item, index) => 
        <>
          <h2>Experienced Disaster {index + 2}</h2>
          {/* a. Uri ng Kalamidad */}
          <h3>a. Uri ng Kalamidad</h3>
          <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Disaster Type</Label>
          <ComboBox
            value={disasterTypeOptions.find(option => option.value === item.disasterType)?.label || ""}
            onChange={(e) => {
              const selectedValue = disasterTypeOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(index, 'disasterType', selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {disasterTypeOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          {item.disasterType === 99 && (
            <Input
              name="disasterTypeOther"
              value={item.disasterTypeOther || ""}
              onInput={(e) => handleInputChange(index, "disasterTypeOther", e.target.value.toUpperCase())}
              placeholder="Specify other disaster type"
              style={{ width: "100%", textTransform: "uppercase" }}
            />
          )}

          {/* b. Uri ng Evacuation Area */}
          <h3>b. Uri ng Evacuation Area</h3>
          <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Evacuation Area</Label>
          <ComboBox
            value={evacuationAreaOptions.find(option => option.value === item.evacuationArea)?.label || ""}
            onChange={(e) => {
              const selectedValue = evacuationAreaOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(index, "evacuationArea", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {evacuationAreaOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          {item.evacuationArea === 99 && (
            <Input
              name="evacuationAreaOther"
              value={item.evacuationAreaOther || ""}
              onInput={(e) => handleInputChange(index, "evacuationAreaOther", e.target.value.toUpperCase())}
              placeholder="Specify other evacuation area"
              style={{ width: "100%", textTransform: "uppercase" }}
            />
          )}

          {/* c. Epekto o Damage na Naranasan */}
          <h3>c. Epekto o Damage na Naranasan</h3>
          <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Disaster Impact</Label>
          <ComboBox
            value={disasterImpactOptions.find(option => option.value === item.disasterImpact)?.label || ""}
            onChange={(e) => {
              const selectedValue = disasterImpactOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(index, "disasterImpact", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {disasterImpactOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          {item.disasterImpact === 99 && (
            <Input
              name="disasterImpactOther"
              value={item.disasterImpactOther || ""}
              onInput={(e) => onFormChange(index, "disasterImpactOther", e.target.value.toUpperCase())}
              placeholder="Specify other disaster impact"
              style={{ width: "100%", textTransform: "uppercase" }}
            />
          )}

          {/* d. Uri ng Tulong na Natanggap */}
          <h3>d. Uri ng Tulong na Natanggap</h3>
          <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Assistance Type</Label>
          <ComboBox
            value={assistanceTypeOptions.find(option => option.value === item.assistanceType)?.label || ""}
            onChange={(e) => {
              const selectedValue = assistanceTypeOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(index, "assistanceType", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {assistanceTypeOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          {item.assistanceType === 99 && (
            <Input
              name="assistanceTypeOther"
              value={item.assistanceTypeOther || ""}
              onInput={(e) => handleInputChange(index, "assistanceTypeOther", e.target.value.toUpperCase())}
              placeholder="Specify other assistance type"
              style={{ width: "100%", textTransform: "uppercase" }}
            />
          )}

          {/* e. Pinanggalingan ng Tulong */}
          {item.assistanceType !== 7 && <>
            <h3>e. Pinanggalingan ng Tulong</h3>
            <Label style={{ fontWeight: "bold", fontSize: "1rem" }}>Select Assistance Source</Label>
            <ComboBox
              value={assistanceSourceOptions.find(option => option.value === item.assistanceSource)?.label || ""}
              onChange={(e) => {
                const selectedValue = assistanceSourceOptions.find(option => option.label === e.target.value)?.value || null;
                handleInputChange(index, "assistanceSource", selectedValue);
              }}
              style={{ width: "100%", marginBottom: "1rem" }}
            >
              {assistanceSourceOptions.map(option => (
                <ComboBoxItem key={option.value} text={option.label} />
              ))}
            </ComboBox>
            {item.assistanceSource === 99 && (
              <Input
                name="assistanceSourceOther"
                value={item.assistanceSourceOther || ""}
                onInput={(e) => handleInputChange(index, "assistanceSourceOther", e.target.value.toUpperCase())}
                placeholder="Specify other assistance source"
                style={{ width: "100%", textTransform: "uppercase" }}
              />
            )}
          </>}
          <Button design="Negative" onClick={() => handleDeleteEntry(index)} style={{marginRight: '1rem'}}>
            Delete Entry
          </Button>
          </> 
          
          )}
          <Button design="Emphasized" onClick={addExtraExperiencedDisaster}>
            Add Entry 
          </Button>
      </>}
      
    </div>
  );
};

export default SocioeconomicForm5;